$(document).ready(function () {
  $("#mobileMenuButton").click(function () {
    $("#mobileNav").slideToggle();
  });

  $("#mobileNav a").click(function () {
    $("#mobileNav").slideToggle();
  });

  $(".heading-24").click(function () {
    window.scrollTo(0, 0);
  });

  var header = $("#shopify-section-header");
  var headerOffset = header.offset().top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      //header.addClass("sticky");
    } else {
      //header.removeClass("sticky");
    }
  });

  function checkCustomVisibility() {
    $(".customFadeInElement").each(function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        $(this).addClass("customVisible");
      }
    });
  }

  $(window).on("scroll resize", checkCustomVisibility);
  $(window).trigger("scroll");

  $(window).on(
    "resize",
    debounce(function () {
      //location.reload();
    }, 250)
  );

  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  // Add active class on click
  $(".nav-link-3.scrollToAnchorLink").on("click", function (event) {
    event.preventDefault();
    $(".nav-link-3").removeClass("active");
    $(this).addClass("active");

    var target = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top,
      },
      500
    );
  });

  const $desktopLaptopNav = $("#desktopLaptopNav");

  function handleNavLinksScroll() {
    $(window).on("scroll.navLinks", function () {
      var scrollPos = $(window).scrollTop();

      $(".nav-link-3").each(function () {
        var href = $(this).attr("href");
        var target = $(href);

        var sectionOffset = target.offset().top - 100;

        if (scrollPos >= sectionOffset) {
          $(".nav-link-3").removeClass("active");
          $(this).addClass("active");
        }
      });
    });
  }

  function handleDesktopScroll() {
    $("#webflowNav").hide();
    $(window)
      .on("scroll.desktopNav", function () {
        if ($(this).scrollTop() >= 1200) {
          $desktopLaptopNav.addClass("hiddenDiv");
          $("#webflowNav").show();
        } else {
          $desktopLaptopNav.removeClass("hiddenDiv");
          $("#webflowNav").hide();
        }
      })
      .trigger("scroll");
  }

  function adjustVisibility() {
    if ($(window).width() <= 1024) {
      $desktopLaptopNav.addClass("hiddenDiv");
      $(window).off("scroll.desktopNav");
    } else {
      handleDesktopScroll();
    }
  }

  //adjustVisibility();
  handleDesktopScroll();
  //handleNavLinksScroll();

  //$(window).on("resize", adjustVisibility);
});

$(document).ready(function () {
  function triggerViewportAnimations() {
    $(".viewport-anim-element").each(function (index) {
      const $element = $(this);
      const elementOffsetTop = $element.offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (scrollTop + windowHeight > elementOffsetTop) {
        setTimeout(() => {
          $element.addClass("viewport-anim-visible");
        }, index * 10); // Delay for cascading effect
      }
    });
  }

  $(window).on("scroll", triggerViewportAnimations);
  $(window).on("load", triggerViewportAnimations); // Trigger animation on page load

  function triggerViewportAnimations2() {
    $(".viewport-anim-element2").each(function (index) {
      const $element = $(this);
      const elementOffsetTop = $element.offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (scrollTop + windowHeight > elementOffsetTop) {
        setTimeout(() => {
          $element.addClass("viewport-anim-visible2");
        }, index * 100); // Delay for cascading effect
      }
    });
  }

  $(window).on("scroll", triggerViewportAnimations2);
  $(window).on("load", triggerViewportAnimations2); // Trigger animation on page load

  var $filmstripInner = jQuery(".expert-filmstrip-inner");
  var $clonedContent = $filmstripInner.html();
  $filmstripInner.append($clonedContent); // Duplicate for seamless loop

  var $filmstripInner2 = jQuery(".expert-filmstrip-inner2");
  var $clonedContent2 = $filmstripInner2.html();
  $filmstripInner2.append($clonedContent2); // Duplicate for seamless loop
});

document.addEventListener("DOMContentLoaded", () => {
  const uniqueCounterElement = document.getElementById("uniqueCounter");
  const uniqueCounterTargetValue = 5000000; // End value
  const uniqueCounterDuration = 1500; // Animation duration in ms
  const uniqueCounterInterval = 10; // Interval in ms

  const uniqueCounterObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Start counter animation
          let uniqueCounterCurrentValue = 0;
          const uniqueCounterSteps =
            uniqueCounterDuration / uniqueCounterInterval;
          const uniqueCounterIncrement = Math.ceil(
            uniqueCounterTargetValue / uniqueCounterSteps
          );

          const uniqueCounterIntervalId = setInterval(() => {
            uniqueCounterCurrentValue += uniqueCounterIncrement;
            if (uniqueCounterCurrentValue >= uniqueCounterTargetValue) {
              uniqueCounterCurrentValue = uniqueCounterTargetValue;
              clearInterval(uniqueCounterIntervalId);
            }
            $("#uniqueCounter").text(
              uniqueCounterCurrentValue.toLocaleString()
            );
          }, uniqueCounterInterval);

          observer.unobserve(uniqueCounterElement); // Stop observing once animation starts
        }
      });
    }
  );

  uniqueCounterObserver.observe(uniqueCounterElement);
});

// Menu functions - consolidated
$(document).ready(function () {
  $(".burger-menu1A").click(function () {
    if ($(".main-content-container1").hasClass("menu-open")) {
      $(".main-content-container1").removeClass("menu-open");
      $(".mobile-menu1B").css("left", "-250px");
      $("body").removeClass("no-scroll"); // Re-enable scrolling
    } else {
      $(".main-content-container1").addClass("menu-open");
      $(".mobile-menu1B").css("left", "0");
      $("body").addClass("no-scroll"); // Disable scrolling
    }
  });

  function toggleMenu(buttonClass, panelId) {
    $(buttonClass).click(function () {
      var $panelCollapse = $(panelId);
      var $icon = $(this).find(".lin");

      // Close any open panels
      $("#pushy-menu .panel-collapse.in")
        .not($panelCollapse)
        .slideUp()
        .removeClass("in");
      $("#pushy-menu .lin-arrow-up")
        .not($icon)
        .removeClass("lin-arrow-up")
        .addClass("lin-arrow-down");

      // Toggle the clicked panel
      if ($panelCollapse.is(":visible")) {
        $panelCollapse.slideUp().removeClass("in");
        $icon.removeClass("lin-arrow-up").addClass("lin-arrow-down");
      } else {
        $panelCollapse.slideDown().addClass("in");
        $icon.removeClass("lin-arrow-down").addClass("lin-arrow-up");
      }
    });

    $("#pushy-menu .lin.lin-arrow-down").on("click", function () {
      $(this).toggleClass("lin-arrow-down lin-arrow-up");
    });
  }

  toggleMenu(
    "#pushy-menu .second_level_drop_link.products_2Button",
    "#pushy-menu #products_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.services_2Button",
    "#pushy-menu #services_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.support_4Button",
    "#pushy-menu #support_4"
  );

  // Show dialog and disable vertical scroll
  $("#nav-search-dialog-button").on("click", function () {
    $("#nav-search-dialog").show();
    $("#nav-search-dialog").attr("style", "display: block !important;");
    $("body").css("overflow", "hidden");
  });

  // Hide dialog and enable vertical scroll
  $("#nav-search-dialog-exit").on("click", function () {
    $("#nav-search-dialog").hide();
    $("#nav-search-dialog").attr("style", "display: none !important;");
    $("body").css("overflow", "auto");
  });

  $(".dropdown-products, .dropdown-support, .dropdown-services").hover(
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").show();
    },
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").hide();
    }
  );

  $(".dropdown-menu").hover(
    function () {
      $(this).show();
    },
    function () {
      $(this).hide();
    }
  );

  $(".lin.lin-arrow-down").on("click", function () {
    $(this).toggleClass("lin-arrow-down lin-arrow-up");
  });

  $("#closeMobileMenu, .no-scroll").on("click", function () {
    $("#pushy-menu-btn").trigger("click");
  });
});

// Videos
$(document).ready(function () {
  $("#repairSolutions2AppVideo").on("click", function () {
    const video = $("#appVideo")[0];
    video.currentTime = 0;
    video.play();
    $("body").addClass("no-scroll2");
    $("#videoModal1, #videoModal1background").show();
  });

  $("#closeRS2appVideo").on("click", function () {
    const video = $("#appVideo")[0];
    video.pause();
    video.currentTime = 0;
    $("body").removeClass("no-scroll2");
    $("#videoModal1, #videoModal1background").hide();
    $("#firstThumbnail").click();
  });

  let observer = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        let video = $(entry.target).find("video")[0]; // Get the video inside the row
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0; // Reset video when out of view
        }
      });
    },
    { threshold: 0.5 }
  ); // Adjust threshold if needed

  $(
    "#knowWhatAboutYourCar .row .actualImageWrapper, #builtWith .introVideoWrapper"
  ).each(function () {
    observer.observe(this);
  });
});

$(document).ready(function () {
  // Reset scroll on load
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 0);

  // Reset scroll on refresh
  $(window).on("beforeunload", function () {
    window.scrollTo(0, 0);
  });
});
